import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SheetsAppContextDirective } from '@modules/sheets/directives/app-sheets-app-context.directive';
import { SheetFolder } from '@modules/sheets/types/sheet-folder';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-sheet-folder-shared',
  templateUrl: './sheet-folder-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SheetsAppContextDirective,
    IconComponent,
    DateFormatPipe,
    ItemDescriptionComponent,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
  ],
})
export class SheetFolderSharedComponent extends SharedBaseComponent<SheetFolder> {
  protected override stitchType = StitchType.SHEET_FOLDER;

  protected get sheetFolder(): SheetFolder {
    return this.stitchItem?.();
  }
}
